import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Common from '../../services/common.js';
import Basic from '../../Components/Basic/Basic';
import Toast from '../../Components/Toast/Toast';
import './UploadCustomerDoc.css';

const UploadCustomerDoc = () => {
  const [errors, setErrors] = useState([]);
  const [docFile, setDocFile] = useState(null);
  const [token, setToken] = useState('');
  const [linkCode, setLinkCode] = useState('');
  const [docName, setDocName] = useState('Merchant Document');
  const [docFileError, setDocFileError] = useState('');
  const [form, setForm] = useState({
    doc_file_name: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toastRef = useRef();
  const fileInputRef = useRef();
  const errorBlockRef = useRef();
  
  const STORAGE_KEY = "caprock-local";
  const localStorageData = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

  useEffect(() => {
    // Get URL parameters
    const urlToken = localStorage.getItem("jwtToken") ? "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3QiLCJhdWQiOiJodHRwOlwvXC9sb2NhbGhvc3QiLCJpYXQiOjE3NTYyMDUwODMsIm5iZiI6MTc1NjIwNTA4MywiZXhwIjoxNzU2MjkxNDgzLCJzdWIiOiJ1c2VyX1RXQ08xWHlDNzEiLCJqdGkiOiI3YmQ5YWRjNC1lN2U3LTRjZTgtYmEzNy1mYTIyMjdlMDljMjgiLCJhdXRoX2NvZGUiOiJlUkM2RksifQ.2th-OoePcM7-lg28Dflnmr7MGi4zqMUyZdAEudaUtRQ" : null;
    const urlLinkCode = searchParams.get('ltoken');
    
    setToken(urlToken);
    setLinkCode(urlLinkCode);
    
    // Check token validity
    tokenAlert();
    
    // Get document details if link code exists
    if (urlLinkCode && urlLinkCode !== '') {
      getLinkDetails(urlLinkCode);
    }
    
    // Set document title
    document.title = `${docName} || Caprock Merchant Platform`;
  }, [searchParams, docName]);

  const tokenAlert = () => {
    if (!token) {
      // alert('This URL is invalid please contact caprock support team');
      window.location.href = 'https://caprock.com.au';
    }
  };

  const getDocDetails = (docToken) => {
    Common.get_doc_details(docToken)
      .then(response => {
        if (response.data && response.data.success === 200) {
          const docData = response.data.doc_data;
          setDocName(docData.doc_name);
          document.title = `${docData.doc_name} || Accountant document`;
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const getLinkDetails = (linkCode) => {
    Common.get_link_details(linkCode)
      .then(response => {
        if (response.data && response.data.success !== 200) {
          alert('Link expired!');
          window.location.href = "https://caprock.com.au";
        } else {
          const sdocName = response.data.link_info['doc_name'] || response.data.link_info['link_name'];
          setDocName(sdocName);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const fetchFile = (event) => {
    const file = event.target.files[0];
    if (event.target.name === 'doc_file') {
      setDocFile(file);
      setForm(prev => ({ ...prev, doc_file_name: file.name }));
      setDocFileError('');
    }
  };

  const submitForm = (e) => {
    e.preventDefault();
    
    if (!docFile) {
      setDocFileError('Please select valid document for upload.');
      toastRef.current?.miralToast(
        'Warning',
        'Please select valid document for upload.',
        '',
        false
      );
      return false;
    }

    const formData = new FormData();
    formData.append('doc_file', docFile);
    formData.append('token', token);
    formData.append('doc_name', docName);
    formData.append('doc_type', 'requested');
    formData.append('link_code', linkCode);

    setIsSubmitting(true);

    const url = Common.base_url() + 'upload-document';

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success === 200) {
        toastRef.current?.miralToast(
          'Success',
          data.message,
          '',
          false
        );
        setTimeout(() => {
          navigate('/sign-in');
        }, 2500);
      } else {
        toastRef.current?.miralToast(
          'Warning',
          data.message,
          '',
          false
        );
      }
    })
    .catch(error => {
      console.error('Upload error:', error);
      toastRef.current?.miralToast(
        'Error',
        'An error occurred during upload',
        '',
        false
      );
    })
    .finally(() => {
      setIsSubmitting(false);
    });
  };

  const openModal = (id) => {
    setShowModal(true);
  };

  const closeModal = (id) => {
    setShowModal(false);
  };

  const removeErr = (event) => {
    // This function can be implemented if needed
  };

  return (
    <>
      <Basic />
      <section className="closefriend-hero background-white">
        <div className="container d-flex  justify-content-center mt-5">
          <form method="POST" action="/" className="my-1" onSubmit={submitForm}>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                <div className="login-card">
                  <div className="login-body">
                    <div className="row">
                      <div className="col-md-12 col-12">
                        <p style={{
                          fontSize: '2rem',
                          fontWeight: 700,
                          letterSpacing: '0.1rem',
                          lineHeight: 'normal'
                        }}>
                          Upload your {docName} !
                        </p>
                      </div>
                    </div>
                    <div className="form-group mt-1 mb-0">
                      <input
                        onChange={fetchFile}
                        id="doc_file"
                        type="file"
                        className="form-control selected-field"
                        name="doc_file"
                        required
                        ref={fileInputRef}
                      />
                      <small className="errorMsg danger ml-2">{docFileError}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                <div className="row justify-content-center mx-md-0 mx-1 mb-1 mt-0">
                  <div className="col-md-12 col-12 px-1">
                    
                    <button
                      id="subBtn"
                      type="submit"
                      className="btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Processing ... ' : 'Upload Now'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ overflowY: 'scroll' }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Please fix this</h5>
                <button
                  type="button"
                  onClick={() => closeModal('exampleModal')}
                  className="btn btn-secondary"
                >
                  Close
                </button>
              </div>
              <div className="modal-body">
                {errors.length > 0 && (
                  <div ref={errorBlockRef} id="errorBlock">
                    {errors.map((error, key) => (
                      <div key={key} className="alert alert-danger">
                        {error}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast Component */}
      <Toast ref={toastRef} />
    </>
  );
};

export default UploadCustomerDoc;
